import { ComparisonItemBasedProposalDAOInterface, ProposalDAOInterface, ProposalDAOInterfaces } from './ProposalDAO';
import * as ProposalNS from '../Proposal';
import * as ProposalElementNS from '../ProposalElements';

class UnsupportedDataAccessObject {}

type DAOFunction = (proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement) => ProposalDAOInterface;

export class DAOManager {
  private static instance: DAOManager | null = null;

  mappings: Map<ProposalNS.DAOType, DAOFunction>;

  public static getInstance() {
    if (!DAOManager.instance) {
      DAOManager.instance = new DAOManager();
    }
    return DAOManager.instance;
  }

  private constructor() {
    this.mappings = new Map();
  }

  public register(type: ProposalNS.DAOType, f: DAOFunction) {
    this.mappings.set(type, f);
  }

  public buildDAO(
    type: ProposalNS.DAOType,
    proposal: ProposalNS.Proposal,
    proposalElement: ProposalElementNS.ProposalDataElement,
    sectionIteratorIndex?: number,
  ): ProposalDAOInterface {
    const f = this.mappings.get(type);
    if (!f) {
      throw UnsupportedDataAccessObject;
    }
    const dao: ProposalDAOInterface = f(proposal, proposalElement);
    if (sectionIteratorIndex != null) {
      const localDAO: ComparisonItemBasedProposalDAOInterface | undefined = dao.getInterface<ComparisonItemBasedProposalDAOInterface>(
        ProposalDAOInterfaces.ItemFields,
      );
      if (localDAO) {
        localDAO.setSectionIteratorIndex(sectionIteratorIndex);
      }
    }
    dao.buildDAO();
    return dao;
  }

  public clear() {
    this.mappings.clear();
  }
}
